"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.threeDSPopupCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var threeDSPopupCreator = function (event) {
    var eventData = {
        action: analytics_layer_1.PopupLoadEventNames.ThreeDSPopup,
        event: 'popup-load',
        eventInfo: 'popup-load',
        popup: {
            "name": event.eventData.popup.name || consts_1.NOT_AVAILABLE
        }
    };
    return eventData;
};
exports.threeDSPopupCreator = threeDSPopupCreator;
